import Header from './fragment-sys/header.js';
import Navi from './fragment-sys/navi.js';
import Footer from './fragment-sys/footer.js';
import '@assets/css/system.css';
import '@assets/css/sys-content.css';

const SysMainLayout = ({ children }) => {
	const handleChildChange = (item, parentMenu) => {
		sessionStorage.setItem('page::path', item.to);
		sessionStorage.setItem('page::title', item.label);
		sessionStorage.setItem('page::breadcumb', parentMenu + ' > ' + item.label);
	};

	return (
		<div style={{
			display: 'flex',
			flexDirection: 'column',
			minHeight: '100vh',
			overflow: 'visible'
		}}>
			<Header />
			<Navi onChange={handleChildChange}/>
			<main style={{ flex: '1 0 auto' }}>
				<div className="container-fluid mt-2">
					{/* Page Content */}
					{children}
				</div>
			</main>
			<Footer />
		</div>
	);
};

export default SysMainLayout;